import { Input } from '@angular/core';
import { ChangeDetectorRef, Component, OnInit, ViewChild, Injectable, NgModule } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject } from 'rxjs';
import { DevicePilomat } from '../model/devicePilomat';
import { DeviceService } from '../service/device.service';
import { Log } from '../util/log';
import { FormControl } from "@angular/forms";
import { DateHelper } from '../util/dateHelper';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { Subject } from 'rxjs';
import { NumberLiteralType } from 'typescript';
import { DateAdapter } from '@angular/material/core';
import { ExecutionsLogEvent } from '../model/ExecutionsLogEvent';

@Component({
  selector: 'app-automations-log',
  templateUrl: './automations-log.component.html',
  styleUrls: ['./automations-log.component.css']
})

export class AutomationsLogComponent implements OnInit {

  @Input() device: DevicePilomat;
  @ViewChild('logtable', { static: true }) table;
  @ViewChild('logloader', { static: true }) loader;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  fromFormControl: FormControl;
  toFormControl: FormControl;
  logDateTo: Date;
  logDateFrom: Date;
  showDatePickers: Boolean = false;
  displayedColumns: string[] = ['date', 'execution', 'result', 'executionType'];

  logList: ExecutionsLogEvent[];
  dataSource: MatTableDataSource<ExecutionsLogEvent>;
  filterString: string = "";

  pageEvent: PageEvent;
  pageSize: number = 200;
  maxPages: number = 0;
  pageLength: number = 0;
  tableItemsTotalCounter: number = 0;
  pageSizeOptions: number[] = [200];
  currentPage: number = 0;

  pickedTimeRangeValue: string = "1";

  constructor(
    private deviceService: DeviceService,
    private cdRef: ChangeDetectorRef,
    private dateAdapter: DateAdapter<any>) {
    this.dateAdapter.setLocale($localize`:@@devicelog_datepicker_locale:it`);

  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    this.loader.showLoading();
    this.logDateTo = new Date();
    this.logDateFrom = new Date();
    this.logDateTo.setHours(23, 59, 59);
    this.logDateFrom.setHours(0, 0, 0);

    this.toFormControl = new FormControl(this.logDateTo);
    this.fromFormControl = new FormControl(this.logDateFrom);

    setTimeout(() => {

      // this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo));
      this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), 0);
    });
  }

  setLogTimeRange(picked: any) {
    this.pickedTimeRangeValue = picked.value;

    if (picked.value == "1") {
      this.logDateTo = new Date();
      this.logDateFrom = new Date();
      this.logDateTo.setHours(23, 59, 59);
      this.logDateFrom.setHours(0, 0, 0);
      this.showDatePickers = false;
      this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), 0);

      Log.debug(DateHelper.formatDateForApi(this.logDateFrom));
      Log.debug(this.logDateFrom.getTimezoneOffset());
      Log.debug(DateHelper.formatDateForApi(this.logDateTo))
      Log.debug(this.logDateTo.getTimezoneOffset())
    } else if (picked.value == "2") {
      this.logDateTo = new Date();
      this.logDateFrom = new Date();

      this.logDateTo.setDate(this.logDateTo.getDate() - 1);
      this.logDateFrom.setDate(this.logDateFrom.getDate() - 1);

      this.logDateTo.setHours(23, 59, 59);
      this.logDateFrom.setHours(0, 0, 0);
      this.showDatePickers = false;
      this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), 0);

      Log.debug(DateHelper.formatDateForApi(this.logDateFrom));
      Log.debug(DateHelper.formatDateForApi(this.logDateTo))
    } else if (picked.value == "3") {
      this.showDatePickers = true;
    }
  }

  refreshData() {
    this.loader.showLoading();
    if (this.pickedTimeRangeValue == "1") {
      this.logDateTo = new Date();
      this.logDateFrom = new Date();

      this.logDateTo.setHours(23, 59, 59);
      this.logDateFrom.setHours(0, 0, 0);

      this.showDatePickers = false;
      this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), 0);
    } else if (this.pickedTimeRangeValue == "2") {
      this.logDateTo = new Date();
      this.logDateFrom = new Date();

      this.logDateTo.setDate(this.logDateTo.getDate() - 1);
      this.logDateFrom.setDate(this.logDateFrom.getDate() - 1);

      this.logDateTo.setHours(23, 59, 59);
      this.logDateFrom.setHours(0, 0, 0);

      this.showDatePickers = false;
      this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), 0);
    } else if (this.pickedTimeRangeValue == "3") {
      this.confirmDateSelection();
      this.loader.hideLoading();
    }
  }

  confirmDateSelection() {
    Log.debug("Dates confirmed");

    if (this.fromFormControl.value) {
      this.logDateFrom = new Date(this.fromFormControl.value);
    }
    if (this.toFormControl.value) {
      this.logDateTo = new Date(this.toFormControl.value);
    }

    this.logDateTo.setHours(23, 59, 59)
    this.logDateFrom.setHours(0, 0, 0)

    this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), 0);

  }

  onKey(event: any) {

    this.filterString = event.target.value;

    this.table.dataSource.filter = this.filterString.trim().toLowerCase();
  }

  filterTable(data: ExecutionsLogEvent, filter: string): boolean {
    if (data.message && data.message.toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    if (data.execution && data.execution.toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    if (data.executionType && data.executionType.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    return false;
  }

  loadData(dateFrom: string, dateTo: string, page: number) {
    this.loader.showLoading();
    this.currentPage = page;

    this.deviceService.getExecutionsLogCount(this.device.serial, dateFrom, dateTo).subscribe(data => {

      this.tableItemsTotalCounter = data.count;
      this.maxPages = Math.ceil(data.count / this.pageSize);

      Log.debug("getExecutionsLogCount - tableItemsTotalCounter:  " + this.tableItemsTotalCounter + "  maxPages:" + this.maxPages);

      const obs = this.deviceService.getExecutionsLogWithDate(this.device.serial, dateFrom, dateTo, page);
      obs.subscribe(data => {

        this.logList = data;

        this.table.dataSource = new MatTableDataSource(this.logList);
        this.table.dataSource.filterPredicate = this.filterTable;
        this.table.dataSource.sort = this.sort;
        this.table.dataSource.filter = this.filterString.trim().toLowerCase();
        this.cdRef.detectChanges();
        this.loader.hideLoading();

      }, error => {
        Log.debug(" automations-log loadData Error");
        this.loader.showError();
      });

    });
  }

  changePage(event?: PageEvent) {

    Log.debug("changePage - pageIndex:  " + event.pageIndex);

    this.currentPage = event.pageIndex;
    this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), this.currentPage);
  }
}